import React, {FC} from 'react';

import {useGetDoctorDetailsFromTheFirstItem} from 'desktop/hooks/useGetDoctorDetailsFromTheFirstItem/useGetDoctorDetailsFromTheFirstItem';

import {ContinueShoppingButton} from '../continueShoppingButton/continueShoppingButton';

import s from '../successMessageWithDash.scss';

/**
 * Success screen on contact lenses
 * @returns {React.ReactNode} react template
 */
export const WeGotIt: FC = () => {
    const doctorDetails = useGetDoctorDetailsFromTheFirstItem();

    return (
        <div className={s.wrapper}>
            <p className={s.descriptionTop}>
                <strong>We got it:</strong> {doctorDetails.patientName}
                <br /> {doctorDetails.name || doctorDetails.organizationName}, {doctorDetails.city},{' '}
                {doctorDetails.regionCode}
            </p>
            <div className={s.dash} />
            <p className={s.descriptionBottom}>
                We will contact your Dr. to verify your prescription
            </p>
            <ContinueShoppingButton />
        </div>
    );
};
